module.exports = __webpack_public_path__ + "fonts/pts.1449638.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pts.ttf?1k5nh7
// module id = 1103
// module chunks = 0